/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SuccessfulLogoutFieldsFragment = {
  readonly __typename?: 'LogoutSuccess';
  readonly csrf: string;
};

export type LogoutMutationVariables = Types.Exact<{
  input: Types.LogoutInput;
}>;

export type LogoutMutation = {
  readonly __typename?: 'Mutation';
  readonly logout:
    | { readonly __typename: 'LogoutSuccess'; readonly csrf: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const SuccessfulLogoutFieldsFragmentDoc = gql`
  fragment SuccessfulLogoutFields on LogoutSuccess {
    csrf
  }
`;
export const LogoutDocument = gql`
  mutation Logout($input: LogoutInput!) {
    logout(input: $input) {
      __typename
      ...SuccessfulLogoutFields
      ...ValidationErrorFields
    }
  }
  ${SuccessfulLogoutFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
  );
}
